import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import DoughnutChart from '../../../../controls/DoughnutChart'
import TitledLabel from '../../../../controls/TitledLabel'
import { localize } from '../../../../util/Localizer'
import Columns from '../../../../styles/columns'

class DeductibleItem extends Component {
  constructor () {
    super()
    this.chartDeductibleFamilyRef = React.createRef()
    this.chartDeductibleIndividualRef = React.createRef()
  }

  get chartDeductibleIndividual () {
    return this.chartDeductibleIndividualRef.current
  }

  get chartDeductibleFamily () {
    return this.chartDeductibleFamilyRef.current
  }

  render () {
    const props = this.props
    const data = props.content
    let familyChartValues = [ data.familyBalanceAmount.toFixed(2), data.familyAccumilatedAmount.toFixed(2) ]
    let individualChartValues = [ data.individualBalanceAmount.toFixed(2), data.individualAccumilatedAmount.toFixed(2) ]
    let chartLabels = [localize('pages.benefitDetails.deductible.available'), localize('pages.benefitDetails.deductible.spent')]
    return (
      <div>
        <Row>
          <Col {...Columns.max3} className='clearPLR'>
            <TitledLabel title='pages.benefitDetails.deductible.famDeductibleAmount' value={data.familyDeductableAmount} format='currency' />
            <TitledLabel title='pages.benefitDetails.deductible.indDeductibleAmount' value={data.individualDeductableAmount} format='currency' />
            <TitledLabel title='pages.benefitDetails.common.period' value={[data.fromDate, data.toDate]} format='dateRange' />
          </Col>
          <Col {...Columns.max3} className='chartCol'>
            <p className='titledLabelTitle'>{localize('pages.benefitDetails.deductible.remainingFamDeductible')}</p>
            <DoughnutChart ref={this.chartDeductibleFamilyRef}
              index={`deductibleFamily${props.deductibleIndex}`}
              defaultChartLabel={chartLabels[0]}
              defaultChartValue={data.familyBalanceAmount}
              chartValues={familyChartValues}
              chartLabels={chartLabels}
              className='doughnutChart'
              selectedLabelClasses='hidden-xs'
              alt={`${localize('pages.benefitDetails.deductible.doughnut.alt1.family')} ${data.description}. ${localize('pages.benefitDetails.deductible.doughnut.alt2')} $${familyChartValues[0]}. ${localize('pages.benefitDetails.dollarMax.doughnut.alt4')} $${familyChartValues[1]}.`} />
          </Col>
          <Col {...Columns.max3} className='chartCol'>
            <p className='titledLabelTitle'>{localize('pages.benefitDetails.deductible.remainingIndDeductible')}</p>
            <DoughnutChart ref={this.chartDeductibleIndividualRef}
              index={`deductibleIndividual${props.deductibleIndex}`}
              defaultChartLabel={chartLabels[0]}
              defaultChartValue={data.individualBalanceAmount}
              chartValues={individualChartValues}
              chartLabels={chartLabels}
              className='doughnutChart'
              selectedLabelClasses='hidden-xs'
              alt={`${localize('pages.benefitDetails.deductible.doughnut.alt1.individual')} ${data.description}. ${localize('pages.benefitDetails.deductible.doughnut.alt2')} $${individualChartValues[0]}. ${localize('pages.benefitDetails.dollarMax.doughnut.alt4')} $${individualChartValues[1]}.`} />
          </Col>
        </Row>
      </div>
    )
  }
}

export default DeductibleItem



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/commonDetails/DeductibleItem.js